/* global __APP_VERSION__, __GIT_SHA__, __BUILD_TIME__ */
import React from 'react';

/**
 * BuildInfo — small footer chip showing version, git SHA, and build timestamp.
 * Values injected by Vite at build time (vite.config.js define).
 * Used in the sidebar so users can report issues with a specific deploy.
 */
export default function BuildInfo() {
  const version = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
  const sha = typeof __GIT_SHA__ !== 'undefined' ? __GIT_SHA__ : 'local';
  const buildTime = typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : null;

  const formattedTime = buildTime
    ? new Date(buildTime).toLocaleString(undefined, {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit',
      })
    : 'dev';

  const tooltip = `Version ${version}\nCommit ${sha}\nDeployed ${buildTime || 'locally'}`;

  return (
    <div
      className="px-3 py-2 text-[10px] text-gray-400 dark:text-gray-500 border-t border-gray-200 dark:border-gray-700 text-center select-text"
      title={tooltip}
    >
      v{version} · {sha} · {formattedTime}
    </div>
  );
}
